<ng-template #AboutUs>
    <a href="javascript:void(0)" class="fw-SideNav_ContactUs text-link" (click)="contactUs()">
        <span>{{ 'NXI_NAVIGATION.CONTACTUS' | translate}}</span>
        <em class="fal fa-phone right margin-right-15"></em>
    </a>
</ng-template>
<ng-template #advisorPanel>
    <div class="mat-menu-panel mat-elevation-z4 fw-Advisor_Menu">
        <div class="mat-menu-content">
            <advisor-info></advisor-info>
            <ng-container *ngIf="entitledForAboutUs">
                <hr>
                <a class="text-link" (click)="contactUs()" tabindex="0" href="javascript:void(0)">{{'ADVISOR.MOREABOUTUS' |
                    translate }}</a>
            </ng-container>
        </div>
    </div>
</ng-template>
<a *ngIf="entitledForAdvisorInfo; else AboutUs" class="fw-SideNav_ContactUs text-link" (click)="openOverlay()">
    <span>{{ 'NXI_NAVIGATION.CONTACTUS' | translate}}</span>
    <em class="fal fa-phone right margin-right-15"></em>
</a>